export default __webpack_public_path__ + "media/zurb/img/services/services/email-design-img-56664268f78adc9b69fbc263009a1ad5.png";